export const CommentType = {
  NORMAL: 'normal',
  CLOSE: 'close', // work closing
}
